import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoadingService } from '@ops/shared-types';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  constructor(public loader: LoadingService) {}

  get isLoading(): boolean {
    return this.loader.getLoading();
  }
}
